const NS = 'http://www.w3.org/2000/svg';

let graph = null;
let graphPromise = null;
let targets = [];
let raf = 0;
let bound = false;
let stopTicket = 0;

function symbolOf(svg) {
  const use = svg.querySelector('use');
  if (!use) return null;
  const href = use.getAttribute('href') || use.getAttribute('xlink:href') || '';
  const id = href.split('#')[1];
  return id ? document.getElementById(id) : null;
}

function barX(node) {
  if (node.localName === 'polygon') {
    const nums = (node.getAttribute('points') || '').trim().split(/[\s,]+/).map(Number);
    let min = Infinity;
    let max = -Infinity;
    for (let i = 0; i < nums.length; i += 2) {
      const x = nums[i];
      if (x < min) min = x;
      if (x > max) max = x;
    }
    return (min + max) / 2;
  }
  const match = (node.getAttribute('d') || '').match(/[Mm]\s*(-?\d+(?:\.\d+)?)[,\s]+(-?\d+(?:\.\d+)?)/);
  return match ? Number(match[1]) : 0;
}

function absoluteSubpaths(d) {
  const tokens = d.match(/[MmZzLlHhVvCcSsQqTtAa]|[-+]?(?:\d*\.\d+|\d+)(?:[eE][-+]?\d+)?/g);
  if (!tokens) return [];

  let i = 0;
  let cx = 0;
  let cy = 0;
  let sx = 0;
  let sy = 0;
  let cmd = '';
  let current = '';
  const subpaths = [];
  const num = (value) => Math.round(value * 1000) / 1000;
  const read = () => Number(tokens[i++]);

  const begin = (x, y) => {
    if (current) subpaths.push(current);
    current = `M${num(x)},${num(y)}`;
    sx = x;
    sy = y;
    cx = x;
    cy = y;
  };

  while (i < tokens.length) {
    if (/[A-Za-z]/.test(tokens[i])) cmd = tokens[i++];
    const rel = cmd === cmd.toLowerCase();
    const op = cmd.toUpperCase();

    if (op === 'M') {
      const x = rel ? cx + read() : read();
      const y = rel ? cy + read() : read();
      begin(x, y);
      cmd = rel ? 'l' : 'L';
      continue;
    }
    if (op === 'Z') {
      current += 'Z';
      cx = sx;
      cy = sy;
      continue;
    }
    if (op === 'H') {
      cx = rel ? cx + read() : read();
      current += `H${num(cx)}`;
      continue;
    }
    if (op === 'V') {
      cy = rel ? cy + read() : read();
      current += `V${num(cy)}`;
      continue;
    }
    if (op === 'L') {
      cx = rel ? cx + read() : read();
      cy = rel ? cy + read() : read();
      current += `L${num(cx)},${num(cy)}`;
      continue;
    }
    return null;
  }

  if (current) subpaths.push(current);
  return subpaths;
}

function piecesOf(symbol) {
  const pieces = [];
  symbol.querySelectorAll('polygon').forEach((poly) => pieces.push(poly));
  symbol.querySelectorAll('path').forEach((path) => {
    const subs = absoluteSubpaths(path.getAttribute('d') || '');
    if (!subs || subs.length <= 1) {
      pieces.push(path);
      return;
    }
    subs.forEach((d) => {
      const slice = path.cloneNode(false);
      slice.setAttribute('d', d);
      pieces.push(slice);
    });
  });
  return pieces;
}

function materialize(svg) {
  if (svg.querySelector('.audio-eq__bar')) return collect(svg);

  const symbol = symbolOf(svg);
  if (!symbol) return null;

  const pieces = piecesOf(symbol);
  if (!pieces.length) return null;

  const host = document.createElementNS(NS, 'g');
  host.setAttribute('class', 'audio-eq__bars');

  const bars = pieces.map((piece, index) => {
    const group = document.createElementNS(NS, 'g');
    group.setAttribute('class', 'audio-eq__bar');
    group.style.animationDelay = `${(index % 9) * 0.17}s`;
    group.style.animationDuration = `${1.7 + (index % 6) * 0.22}s`;
    group.appendChild(piece.cloneNode(true));
    host.appendChild(group);
    return {
      el: group,
      x: barX(piece),
      level: 1,
      idleDuration: group.style.animationDuration
    };
  });

  const viewBox = symbol.getAttribute('viewBox');
  if (viewBox && !svg.getAttribute('viewBox')) svg.setAttribute('viewBox', viewBox);
  const use = svg.querySelector('use');
  if (use) use.replaceWith(host);
  else svg.appendChild(host);
  svg.classList.add('js-audio-eq');

  bars.sort((a, b) => a.x - b.x);
  return { svg, bars };
}

function collect(svg) {
  const bars = [...svg.querySelectorAll('.audio-eq__bar')].map((el) => {
    const shape = el.querySelector('polygon, path');
    return { el, x: shape ? barX(shape) : 0, level: 1, idleDuration: el.style.animationDuration };
  });
  bars.sort((a, b) => a.x - b.x);
  return { svg, bars };
}

function audioNode() {
  return document.querySelector('.js-sound-control');
}

function playing(audio) {
  return !!audio && !audio.paused && !audio.ended;
}

function ensureGraph(audio) {
  if (graph && graph.ctx.state === 'running') return Promise.resolve(graph);
  if (graph) return graph.ctx.resume().then(() => (graph.ctx.state === 'running' ? graph : null));
  if (graphPromise) return graphPromise;

  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return Promise.resolve(null);

  const ctx = new Ctx();
  const resume = ctx.state === 'suspended' ? ctx.resume() : Promise.resolve();
  graphPromise = resume.then(() => {
    if (ctx.state !== 'running') {
      graphPromise = null;
      try { ctx.close(); } catch (e) { /* контекст так и не стартовал */ }
      return null;
    }
    const source = ctx.createMediaElementSource(audio);
    const analyser = ctx.createAnalyser();
    analyser.fftSize = 256;
    analyser.smoothingTimeConstant = 0.82;
    source.connect(analyser);
    analyser.connect(ctx.destination);
    graph = { ctx, analyser, data: new Uint8Array(analyser.frequencyBinCount) };
    return graph;
  }).catch(() => {
    graphPromise = null;
    return null;
  });
  return graphPromise;
}

function paint() {
  if (!graph) return;
  graph.analyser.getByteFrequencyData(graph.data);
  const bins = graph.data.length;
  targets.forEach(({ svg, bars }) => {
    if (!svg.classList.contains('_active')) return;
    const last = Math.max(bars.length - 1, 1);
    bars.forEach((bar, index) => {
      const bin = 1 + Math.floor((index / last) * 36);
      const sample = graph.data[Math.min(bin, bins - 1)] / 255;
      const aim = 0.32 + sample * 1.15;
      bar.level += (aim - bar.level) * 0.38;
      bar.el.style.transform = `scaleY(${bar.level.toFixed(3)})`;
    });
  });
}

function tick() {
  const audio = audioNode();
  if (!playing(audio) || !targets.length) {
    raf = 0;
    return;
  }
  paint();
  raf = requestAnimationFrame(tick);
}

function start() {
  if (raf || !targets.length) return;
  raf = requestAnimationFrame(tick);
}

function stop() {
  if (raf) cancelAnimationFrame(raf);
  raf = 0;
}

function setLive(live, driven) {
  if (live && driven) {
    targets.forEach(({ svg }) => {
      svg.classList.add('is-live', 'is-driven');
    });
    start();
    return;
  }

  targets.forEach(({ svg, bars }) => {
    svg.classList.toggle('is-live', live);
    svg.classList.toggle('is-driven', false);
    bars.forEach((bar, index) => {
      bar.el.style.transform = '';
      if (!live) bar.el.style.animationDuration = bar.idleDuration || '';
      else bar.el.style.animationDuration = `${0.34 + (index % 5) * 0.07}s`;
    });
  });
  stop();
}

function wake() {
  stopTicket += 1;
  const audio = audioNode();
  if (!audio) return;
  ensureGraph(audio).then((ready) => {
    if (playing(audioNode())) setLive(true, !!ready);
  });
}

function scheduleStop() {
  const ticket = ++stopTicket;
  requestAnimationFrame(() => {
    if (ticket !== stopTicket) return;
    if (!playing(audioNode())) setLive(false, false);
  });
}

function bind() {
  const audio = audioNode();
  if (bound || !audio) return;
  bound = true;
  audio.addEventListener('play', wake);
  audio.addEventListener('playing', wake);
  audio.addEventListener('pause', scheduleStop);
  audio.addEventListener('ended', scheduleStop);
}

export default function mountAudioEqualizer() {
  targets = [...document.querySelectorAll('.equalizer__icon.js-show-icon-item')].map(materialize).filter(Boolean);
  bind();
  const audio = audioNode();
  if (playing(audio)) {
    ensureGraph(audio).then((ready) => {
      if (playing(audioNode())) setLive(true, !!ready);
    });
  } else setLive(false, false);
}
